window.tinyMceInit =
{
    height: 270,
    menubar: false,
    skin: 'outside',
    toolbar_groups: {
        paragraphgroup: {
            icon: 'paragraph',
            tooltip: 'Paragraph format',
            items: 'p h1 h2 h3 pre | bullist numlist'
        },
        insertgroup: {
            icon: 'plus',
            tooltip: 'Insert',
            items: 'link image emoticons charmap hr'
        },
    },
    // toolbar_location: 'bottom',
    plugins: 'print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons',
    //https://www.tiny.cloud/docs/advanced/available-toolbar-buttons/  //  link anchor codesample insertfile | pagebreak | save print | preview | template | emoticons
    toolbar: 'undo redo removeformat | bold italic underline strikethrough | formatselect | fontselect fontsizeselect | insertgroup | forecolor backcolor | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | ltr rtl | superscript subscript | fullscreen code',
    toolbar_sticky: true,
    autosave_ask_before_unload: true,
    image_advtab: true,
    font_formats: "Arial Black=arial black,avant garde; Courier New=courier new,courier; Lato Black=lato; Roboto=roboto;  Comic New=Comic Neue;",
    content_style: "@import url('https://fonts.googleapis.com/css2?family=Lato:wght@900&family=Roboto&family=Comic+Neue&display=swap');"
};

window.lightEditorInit =
{
    height: 220,
    menubar: false,
    skin: 'outside',
    toolbar_groups: {
        paragraphgroup: {
            icon: 'paragraph',
            tooltip: 'Paragraph format',
            items: 'p h1 h2 h3'
        },
    },
    plugins: 'code',
    toolbar: 'undo redo removeformat | formatselect | fontselect fontsizeselect | forecolor backcolor | code',
    toolbar_sticky: true,
    autosave_ask_before_unload: true,
    image_advtab: false,
    setup: function (ed) {
        ed.on('keydown', function (e) {

            var allowedKeys = [8, 37, 38, 39, 40, 46]; // backspace, delete and cursor keys
            if (allowedKeys.indexOf(e.keyCode) != -1) return true;

            if(tinyMCE.activeEditor){
                var maxLength = tinyMCE.get(tinyMCE.activeEditor.id).getElement().getAttribute('maxLength');
                // var textLength = ed.getContent({format : 'text'}).length;
                var textLength = window.stripHTML(ed.getContent()).length;
                if (textLength + 1 > maxLength) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
            }
        });

        ed.on('setcontent beforeaddundo', function () {
            if(tinyMCE.activeEditor){
                var maxLength = tinyMCE.get(tinyMCE.activeEditor.id).getElement().getAttribute('maxLength');
                if (ed.getContent().length > maxLength) {
                    return false;
                }
            }
        });

    },
    font_formats: "Arial Black=arial black,avant garde; Courier New=courier new,courier; Lato Black=lato; Roboto=roboto;  Comic New=Comic Neue;",
    content_style: "@import url('https://fonts.googleapis.com/css2?family=Lato:wght@900&family=Roboto&family=Comic+Neue&display=swap');"
    
};